import type { RouteRecordRaw } from 'vue-router';

export const reportRoutes: RouteRecordRaw[] = [
  {
    path: '/report',
    name: 'ReportIndex',
    component: () => import('./views/ReportIndex.vue'),
    meta: {
      title: 'report.index.title',
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/report/synchronize-history',
    name: 'SynchronizeHistory',
    component: () => import('./views/ReportList.vue'),
    meta: {
      title: 'report.list.title',
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/report/reminder-history',
    name: 'ReminderHistory',
    component: () => import('./views/ReminderHistory.vue'),
    meta: {
      title: 'report.reminder.title',
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/report/audit-trail-history',
    name: 'AuditTrailHistory',
    component: () => import('./views/AuditTrail.vue'),
    meta: {
      title: 'report.audit.title',
      requiresAuth: true,
      layout: 'default'
    }
  }
];

export default reportRoutes;
